<div class="row row-padding project-row ">
    <div class="col">   
        <form class="form-signin" action="#" role="form">
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
                <h6 class="error-msg">{{ errorMessage | trans }}</h6>
            </div>
            <div class="form-group">
                <label class="control-label" for="signupName{{user.userId}}">{{ 'customeruseredit.name' | trans }}</label>
                <input (keyup)="validate()" id="signupName{{user.userId}}"  type="text" maxlength="50" 
                class="form-control" name="fullname" [(ngModel)]="user.fullname" style="font-size: 13px!important;">
            </div>
            <div class="form-group">
                <label class="control-label" for="signupJobTitle{{user.userId}}">{{ 'customeruseredit.jobtitle' | trans }}</label>
                <input (keyup)="validate()" id="signupJobTitle{{user.userId}}"  type="text" maxlength="50" class="form-control" 
                name="jobtitle" [(ngModel)]="user.jobtitle" style="font-size: 13px!important;">
            </div>
            <div class="form-group">
                <label class="control-label" for="signupEmail{{user.userId}}">{{ 'customeruseredit.email' | trans }}</label>
                <input disabled="true" id="signupEmail{{user.userId}}" type="email"  maxlength="50" 
                class="form-control" name="email" [(ngModel)]="user.email" style="font-size: 13px!important;">
            </div>
            <!---<div class="form-group ">
                <label class="control-label" for="signupPhone">Phone</label>
                <input (keyup)="validate()" id="signupPhone"  type="text"  maxlength="50" class="form-control" name="phone" [(ngModel)]="user.phone" >
            </div>--->
            <div class="form-group ">
                <label class="control-label" for="signupUsername{{user.userId}}">{{ 'customeruseredit.username' | trans }}</label>
                <input (keyup)="validate()" id="signupUsername{{user.userId}}"  type="text"  maxlength="50" 
                class="form-control" name="username" [(ngModel)]="user.username" style="font-size: 13px!important;">
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group ">
                        <div class="form-check form-check-inline">
                            <input (change)="validate()" [disabled]="!user.isactive" class="form-check-input" type="checkbox" id="sendinvite{{user.userId}}" name="sendinvite" [(ngModel)]="user.sendinvite"  >
                            <label class="f-13 mb-0 font-weight-light" for="sendinvite{{user.userId}}">{{ 'customerusercreate.sendinvitationemail' | trans }}</label>
                        </div>
                        <div *ngIf="!user.sendinvite" class="alert alert-secondary" role="alert">
                            <p class="mb-0">{{ 'customeruseredit.sendalert' | trans }}</p>
                          </div>
                        <div *ngIf="user.sendinvite" class="alert alert-success" role="alert">
                            <p class="mb-0">{{ 'customeruseredit.sendalert2' | trans }}</p>
                          </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group ">
                        <div class="form-check form-check-inline">
                            <input (change)="validate(); toggleActive();" class="form-check-input" type="checkbox" id="activate{{user.userId}}" name="activate" [(ngModel)]="user.isactive"  >
                            <label class="control-label" for="activate{{user.userId}}">{{ 'customeruseredit.activated' | trans }}</label>
                        </div>
                        <div *ngIf="!user.isactive" class="alert alert-secondary" role="alert">
                            <p class="mb-0">{{ 'customeruseredit.activatedalert' | trans }}</p>
                          </div>
                        <div *ngIf="user.isactive" class="alert alert-success" role="alert">
                            <p class="mb-0">{{ 'customeruseredit.activatedalert2' | trans }}</p>
                          </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <!--<div class="col">
                    <button class="btn-close" data-dismiss="modal"><h6 class="btn-save-text">{{ 'customeruseredit.close' | trans }}</h6></button>
                </div>--->
                <div class="col">
                    <button [disabled]="!formIsValid"  data-dismiss="modal" (click)="saveUser()" style="width:100%;" id="signupSubmit{{user.userId}}" type="submit" class="btn-save">
                        <h6 class="btn-save-text">{{ 'customeruseredit.savechanges' | trans }}
                        </h6>
                      </button>
                          </div>

            </div>

        </form>
    </div>
</div>